import React from 'react'
import { RecommendScene } from '@alife/pc-recommend';

export default function Recommend({ strategy, companyId, productId, categoryId, country }: {
  strategy: string,
  companyId: string,
  productId: string,
  categoryId: string,
  country: string
}) {
  return (
    <div
      className={`recommend-layout ${strategy}`}
      detail-module-name={`module_${strategy}`}
    >
      <RecommendScene
        scene="detail"
        module={strategy}
        props={{ companyId, productId, categoryId, country }}
      />
    </div>
  );
}
